/*!
 * Copyright 2017 - 2020 by ChartIQ, Inc.
 * All rights reserved.
 */
// replace with import when ready

import { BaseService } from "../baseService";

import configClient from "../../clients/configClient";
import distributedStoreClient from "../../clients/distributedStoreClient";
import Logger from "../../clients/logger";

Logger.start();

/**
 * The Linker Service receives calls from the linkerClient, and handles communication between linked windows.
 */
class LinkerService extends BaseService {
	linkerStore;

	/**
	
	 * @param {string} params.name name of the service
	 * @param {object} params.startupDependencies
	 * @param {array} params.startupDependencies.clients Clients to wait on before initializing the service
	 * @param {array} params.startupDependencies.services Services to wait on before initializing the service
	 * @param {object} params.shutdownDependencies
	 * @param {array} params.shutdownDependencies.services Services to wait on before shutting down the service
	 * */
	constructor(params) {
		if (!params || params === undefined) params = {};
		params.name = "linkerService";

		super(params);
		this.defaultChannels = [
			{
				name: "group1",
				color: "#8781BD",
				border: "#797381",
			},
			{
				name: "group2",
				color: "#FFE035",
				border: "#FFD803",
			},
			{
				name: "group3",
				color: "#89D803",
				border: "#71CE47",
			},
			{
				name: "group4",
				color: "#FE6262",
				border: "#F83B3B",
			},
			{
				name: "group5",
				color: "#2DACFF",
				border: "#039BFF",
			},
			{
				name: "group6",
				color: "#FFA200",
				border: "#F29A01",
			},
		];
		this.bindCorrectContext();
		this.createRouterEndpoints();
		this.onBaseServiceReady(this.initialize);
		this.start();
	}

	bindCorrectContext() {
		this.initialize = this.initialize.bind(this);
		this.stateChangeHandler = this.stateChangeHandler.bind(this);
	}

	makeKey(windowIdentifier) {
		return windowIdentifier.windowName.replace(/\./g, "_");
	}

	createRouterEndpoints() {
		this.RouterClient.addListener("LinkerService-Event-component-state-changed", this.stateChangeHandler);
	}

	stateChangeHandler(error, message) {
		if (error) {
		} else {
			const key = this.makeKey(message.data);
			this.linkerStore.getValue({ field: `clients.${key}` }, (error, clientValue) => {
				if (!error && clientValue) {
					clientValue.channels = {};
					if (message.data.Finsemble_Linker) {
						if (Array.isArray(message.data.Finsemble_Linker)) {
							message.data.Finsemble_Linker.forEach((channelName) => {
								clientValue.channels[channelName] = true;
							});
						} else {
							clientValue.channels = message.data.Finsemble_Linker;
						}
					}
					this.linkerStore.setValue({
						field: `clients.${key}`,
						value: clientValue,
					});
				}
			});
		}
	}

	/**
	 * Initializes the service
	 *
	 * @param {function} cb Callback
	 */
	async initialize(cb) {
		Logger.system.log("Linker Initialize");

		// Has customer overwritten the channels?
		let channels = await configClient.getValue({
			field: "finsemble.servicesConfig.linker.channels",
		});

		// If not, get channels from config
		if (!channels.data)
			channels = await configClient.getValue({
				field: "finsemble.services.linkerService.channels",
			});

		// Config promise resolution is object.data containing the data, and should probably be just data
		channels = channels.data;

		// If no channels were found use inbuilt channels.
		if (!channels || !channels.length) channels = self.defaultChannels;

		Logger.system.log("Linker Channels", channels);

		distributedStoreClient.createStore(
			{
				store: "Finsemble_Linker",
				global: true,
				values: {
					channels,
					clients: {},
				},
			},
			(err, store) => {
				this.linkerStore = store;
				cb();
			}
		);
	}
}

export default new LinkerService({
	startupDependencies: {},
	shutdownDependencies: {
		services: ["windowService"],
	},
});
